export const MAIN_ROUTE = '/'
export const ADMIN_ROUTE = '/admin'
export const ADMIN_PANEL_ROUTE = '/admin/panel'
export const BASKET_ROUTE = '/basket'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const BUSINESS_ROUTE = '/business'
export const SHOP_ROUTE = '/shop'
export const DEVICE_ROUTE = '/device'
export const CREATE_AN_AD = '/createanad'
export const USER_PROFILE_ADS = '/user-ads'
export const CHAT_ROUTE = '/room'
export const GAME_ROUTE = '/game'
export const CHANGE_PASSWORD = '/change-password'

export const MAILING_ROUTE = '/mailing'
export const PRIVACY_POLICY_ROUTE = '/privacy-policy'
export const RULES_FOR_BUYERS_ROUTE = '/rules-for-buyers'
export const RULES_FOR_SELLERS_ROUTE = '/rules-for-sellers'
export const LICENSE_AGREEMENT_ROUTE = '/license-agreement'
export const SOGLASIE_NA_OBRABOTKU_PERSONALNYH_DANNYH_ROUTE =
	'/soglasie-na-obrabotku-personalnyh-dannyh'
export const LEGAL_INFORMATION_ROUTE = '/legal-information'

export const BASE_URL = window.location.origin

export const SUPPORT_EMAIL = 'support@gearstore.site'

export const legalLinks = [
	{
		title: 'Согласие на получение рекламной и информационной рассылки',
		href: MAILING_ROUTE,
	},
	{
		title: 'Политика обработки и конфиденциальности персональных данных',
		href: PRIVACY_POLICY_ROUTE,
	},
	{
		title: 'Правила для покупателей',
		href: RULES_FOR_BUYERS_ROUTE,
	},
	{
		title: 'Правила размещения объявлений',
		href: RULES_FOR_SELLERS_ROUTE,
	},
	{
		title: 'Согласие на обработку персональных данных',
		href: SOGLASIE_NA_OBRABOTKU_PERSONALNYH_DANNYH_ROUTE,
	},
	{
		title: 'Лицензионное соглашение',
		href: LEGAL_INFORMATION_ROUTE,
	},
]

export const VALIDATE_STYLE = {
	backgroundColor: 'rgba(255, 245, 245, 1)',
	border: '1px solid red',
}
